<main class="font-sans">
  <home-hero />
  <home-feature-freelancers />
  <home-why-use />
  <home-why-freelance />
  <home-how-works />
  <home-browse-freelancers />
  <!--<home-top-portfolios />-->
  <home-blog-posts />
  <!--<home-who-behind />-->
  <join-community />
</main>
